import { render, staticRenderFns } from "./AIVSelect.vue?vue&type=template&id=a59690fa&scoped=true"
import script from "./AIVSelect.vue?vue&type=script&lang=js"
export * from "./AIVSelect.vue?vue&type=script&lang=js"
import style0 from "./AIVSelect.vue?vue&type=style&index=0&id=a59690fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59690fa",
  null
  
)

export default component.exports